/* eslint-disable array-bracket-spacing */
/* eslint-disable computed-property-spacing */
/* eslint-disable template-curly-spacing */
/* eslint-disable react/jsx-curly-spacing */
import React, { Component } from "react";
import { DetilPxContext } from "../../context";
import TableServerSidePagination from "../component/ServerSideTable/TableServerSidePagination";
import moment, { now } from "moment";
import usePuskesmas from "../hooks/usePuskesmas";
import apiService from "../../apiService";
import { confirmedAlert, showLoading, toast } from "../component/Alert";
import ModalUpdateClinic from "./ModalUpdateCLinic";
import ModalUpdateProlanis from "./ModalUpdateProlanis";
import ModalWa from "./ModalWa";

class TablePelayanan extends Component {
  static contextType = DetilPxContext;

  constructor(props) {
    super(props);
    this.cardNameComponentRefs = [];
    this.printListComponentRef = React.createRef();
    this.socket = this.props.socket;
    this.state = {
      headers: props.headers,
      datas: [],
      filteredDatas: [],
      isLoading: true,
      currentPage: 1,
      form: false,
      detilPx: "",
      index: "",
      modal: false,
      modalWa: false,
      modalProlanis: false,
      modalData: "",
      modalWaData: "",
    };
    this.delete = this.delete.bind(this);
    this.deletePatient = this.deletePatient.bind(this);
    this.changeData = this.changeData.bind(this);
    this.PutVisit = this.PutVisit.bind(this);
    this.changeColor = this.changeColor.bind(this);
    this.deleteReglab = this.deleteReglab.bind(this);
  }

  getDataPx = async (data) => {
    showLoading("Menyiapkan Data");
    const param = {
      keyword: {
        visitId: data.id,
      },
      limit: 1,
      frDate: "",
      enDate: "",
    };

    const res = await apiService.post("registration", param);
    if (res?.status === "success.") {
      this.context.changeDetilPx(res.data.data[0]);
      toast({ status: "success", text: "selesai menyiapkan data" });
      this.setAge(res.data.data[0].patients.birth_date);
    }
  };

  setAge = (d) => {
    var b = moment(d);
    var a = new Date();

    a = moment(a);

    var years = a.diff(b, "year");
    b.add(years, "years");

    var months = a.diff(b, "months");
    b.add(months, "months");

    var days = a.diff(b, "days");
    console.log(d, "ok", months, days);
    if (months == 0 && days <= 30) {
      toast({
        status: "warning",
        text: "PASIEN MASUK KATEGORI CKG, TAWARKAN CKG UNTUK PASIEN",
        timer: 10000,
      });
      console.log("toast rametu");
    }
  };

  updateTime = async (id) => {
    let update = await apiService.post("fhir/satu_sehat/in_progress/" + id);
  };

  try = async (e) => {
    const data = this.state.filteredDatas.data[[e.target.value]];
    this.getDataPx(data);
    // this.updateTime(data.id)
    // this.context.changeDetilPx(data);
    if (data.clinics) {
      this.props.history.push("/pelayanan/Resume");
    } else {
      this.props.history.push("/pelayanan/");
    }
  };

  delete(e, data) {
    const deletePatient = this.deletePatient;
    const name = data.patients
      ? data.patients.name + " " + data.patients.last_name
      : "";
    confirmedAlert(
      "Peringatan",
      "Apakah anda akan menghapus " + name,
      function (confirmed) {
        if (confirmed) {
          deletePatient(data);
        } else {
          // NO
        }
      }
    );
  }

  deleteLab(e, data) {
    const deletePatientLab = this.deleteReglab;
    const name = data.patients
      ? data.patients.name + " " + data.patients.last_name
      : "";
    confirmedAlert(
      "Peringatan",
      "Apakah anda akan menghapus Lab atas nama " + name,
      function (confirmed) {
        if (confirmed) {
          deletePatientLab(data);
        } else {
          // NO
        }
      }
    );
  }

  deletePatient = async (data) => {
    const res = await apiService.delete("/registration/delete/" + data.id);
    const dat = this.state.filteredDatas.data.filter(
      (element) => element.id !== data.id
    );
    if (res.code === 200) {
      let res = await apiService.delete("/pcare/pendaftaran/" + data.id);
      if (data.served) {
        res = await apiService.delete("/pcare/kunjungan/" + data.id);
      }
      this.setState((prevState) => ({
        filteredDatas: {
          // object that we want to update
          ...prevState.filteredDatas, // keep all other key-value pairs
          data: dat, // update the value of specific key
        },
      }));
    }
  };

  deleteReglab = async (data) => {
    const res = await apiService.delete(
      "/registration/lab/delete_registration/" + data.id
    );
    const ind = this.state.filteredDatas.data.findIndex(
      (element) => element.id == data.id
    );
    let dat = this.state.filteredDatas.data;
    dat[ind].labs_flags = false;
    if (res.code === 200) {
      this.setState((prevState) => ({
        filteredDatas: {
          // object that we want to update
          ...prevState.filteredDatas, // keep all other key-value pairs
          data: dat, // update the value of specific key
        },
      }));
    }
  };

  componentDidUpdate(prevProps) {
    if (this.props.datas !== prevProps.datas) {
      this.setState({
        datas: this.props.datas,
        filteredDatas: this.props.datas,
        isLoading: false,
      });
      let clinics = [];
      let ref_clinics = [];
      if (this.props.refClinic.length) {
        ref_clinics = this.props.refClinic;
      } else {
        const r = localStorage.getItem("_ref_clinics_");
        if (r) {
          ref_clinics = JSON.parse(r);
        }
      }
      ref_clinics.map((a, k) => {
        if (a.clinic.child.length > 0) {
          clinics.push(...a.clinic.child);
        } else {
          clinics.push(a);
        }
      });
      this.setState({ listClinic: clinics });
    }
    let dt = { status: 0, id: 0 };
    this.socket.on("listedQueue", (data) => {
      if (dt.status != data.status && dt.id != data.id) {
        this.changeColor(data);
        console.log(data);
        dt = data;
      }
    });
  }

  getComponentRef = (i) => {
    return this.cardNameComponentRefs[i];
  };

  handlePageChange = (pageNumber) => {
    this.setState({
      currentPage: pageNumber,
    });
  };

  handleFilter = (flag) => {
    const filteredLists = [];
    if (flag !== "") {
      this.state.datas.map((data) => {
        if (data.flg_prolanis === flag) {
          filteredLists.push(data);
        }
        return "";
      });
      this.setState({
        filteredDatas: filteredLists,
        currentPage: 1,
      });
    } else {
      this.setState({
        filteredDatas: this.state.datas,
      });
    }
    return "";
  };

  changeData(datas) {
    // console.log(datas);
    this.setState({
      filteredDatas: datas,
    });
  }

  call = (currentQueueParam, clinicNameParam, clinicId, data) => {
    this.PutVisit(data);
    let selected_room = JSON.parse(localStorage.getItem("rooms"))
      ? JSON.parse(localStorage.getItem("rooms")).rooms
      : null;
    console.log(selected_room);
    this.socket.emit("callQueue", {
      currentQueue: currentQueueParam,
      clinicName: clinicNameParam,
      room: selected_room,
    });
    this.socket.emit("nextQueue", {
      type: "clinic",
      clinicId: clinicId,
      currentQueue: currentQueueParam,
      room: selected_room,
    });
  };

  changeColor(data) {
    let nowData = this.state.filteredDatas.data;
    let novVisit = nowData.findIndex((a) => a.queue.id == data.id);
    if (novVisit != undefined) {
      console.log(data, "changestate");
      nowData[novVisit]["queue"]["status"] = data.status;
      this.setState((prevState) => ({
        filteredDatas: {
          // object that we want to update
          ...prevState.filteredDatas, // keep all other key-value pairs
          data: nowData, // update the value of specific key
        },
      }));
    }
  }

  PutVisit = async (data) => {
    if (data.queue) {
      let userData = JSON.parse(localStorage.getItem("userData"));
      let status_call =
        userData.paramedic_type_id == "1" ||
        userData.paramedic_type_id == "2" ||
        userData.paramedic_type_id == "99"
          ? 2
          : 1;
      let queue = {
        id: data.queue ? data.queue.id : 0,
        visit_id: data.id,
        status: status_call,
      };
      let nowData = this.state.filteredDatas.data;
      let novVisit = nowData.findIndex((a) => a.queue.id == data.queue.id);
      nowData[novVisit]["queue"]["status"] = status_call;
      this.setState((prevState) => ({
        filteredDatas: {
          // object that we want to update
          ...prevState.filteredDatas, // keep all other key-value pairs
          data: nowData, // update the value of specific key
        },
      }));
      let res = await apiService.put("/apm/queues/status", queue);
      if (res?.code == 200) {
        console.log("emit angkanya");
        this.socket.emit("updateQueue", {
          id: data.queue ? data.queue.id : 0,
          status: status_call,
        });
      }
    }
  };

  setNextRequest = async (queueParam) => {
    const result = await apiService.get(`/apm/queues/call/${queueParam}`);
    if (result) {
      this.socket.emit("nextQueue", {
        type: "registration",
        clinicId: result.data.registration_clinic_id,
        currentQueue: result.data.queue,
      });
    }
  };

  createBUtton(data, i) {
    if (data.served) {
      return (
        <>
          <button
            onClick={(e) => this.try(e, data)}
            className="btn btn-sm btn-success"
            value={i}
          >
            &radic;
          </button>
        </>
      );
    } else {
      return (
        <>
          <button
            onClick={(e) => this.try(e, data)}
            className="btn btn-sm btn-primary"
            value={i}
          >
            +
          </button>
        </>
      );
    }
  }

  createBUttonDelete(data, i) {
    let color = "#ffd600";
    let icon = "flag-checkered";
    let forecolor = "black";
    if (data.prolanis) {
      icon = "check";
      forecolor = "white";
      if (data.prolanis.includes("DM") && data.prolanis.includes("HT"))
        color = "#8bc34a";
      else if (data.prolanis.includes("DM")) color = "#673ab7";
      else if (data.prolanis.includes("HT")) color = "#df4af3";
    }

    return (
      <div>
        {data.labs_flags && (
          <button
            data-toggle="tooltip"
            data-placement="top"
            title="delete laborat"
            onClick={(e) => this.deleteLab(e, data)}
            className="btn btn-sm btn-danger"
            value={i}
          >
            <i className="fa fa-trash">delete lab</i>
          </button>
        )}
        <button
          data-toggle="tooltip"
          data-placement="top"
          title="Edit Klinik"
          onClick={(e) => this.setState({ modalData: data, modal: true })}
          className="btn btn-sm btn-info"
          value={i}
        >
          <i className="fas fa-user-edit"></i>
        </button>
        <button
          data-toggle="tooltip"
          data-placement="top"
          title="Hapus"
          onClick={(e) => this.delete(e, data)}
          className="btn btn-sm btn-danger"
          value={i}
        >
          <i className="fas fa-minus"></i>
        </button>
      </div>
    );
  }

  createProlanisBUtton = (data, i) => {
    let color = "#ffd600";
    let icon = "flag-checkered";
    let forecolor = "black";
    if (data.prolanis) {
      icon = "check";
      forecolor = "white";
      if (data.prolanis.includes("DM") && data.prolanis.includes("HT"))
        color = "#8bc34a";
      else if (data.prolanis.includes("DM")) color = "#673ab7";
      else if (data.prolanis.includes("HT")) color = "#df4af3";
    }

    return (
      <button
        data-toggle="tooltip"
        data-placement="top"
        title="Prolanis"
        onClick={(e) => this.setState({ modalData: data, modalProlanis: true })}
        className="btn btn-sm"
        style={{ backgroundColor: color }}
      >
        <i className={`fas fa-${icon} text-${forecolor}`}></i>
      </button>
    );
  };
  getPrevCLinic(id) {
    let clinic = this.state.listClinic.find((e) => e.clinic_id === id);
    if (clinic) {
      if (clinic.clinic) {
        return clinic.clinic.name;
      } else {
        return clinic.name;
      }
    }
  }
  // createBUttonModal(data, i) {
  //   return (
  //     <button
  //       onClick={(e) => this.delete(e, data)}
  //       className="btn btn-sm btn-indo"
  //       value={i}
  //     >
  //       u
  //     </button>
  //   );
  // }

  render() {
    // console.log(this.state.filteredDatas);
    // const indexOfLastPost = this.state.currentPage * this.props.listsPerPage;
    // const indexOfFirstPost = indexOfLastPost - this.props.listsPerPage;
    // const currentLists = this.state.filteredDatas.slice(
    //   indexOfFirstPost,
    //   indexOfLastPost
    // );
    // console.log(this.state.listClinic)
    return (
      <div>
        <TableServerSidePagination
          headers={this.state.headers}
          columnMapper={(data, i) => [
            <>
              {this.createProlanisBUtton(data, i)}
              <button
                type="button"
                // disabled={
                //   !moment(
                //     data.queue ? data.queue.created_at : '',
                //     'YYYY-MM-DD'
                //   ).isSame(moment().format('YYYY-MM-DD'))
                // }
                className={
                  data.queue
                    ? data.queue.status
                      ? data.queue.status == 1
                        ? "btn  btn-info"
                        : "btn  btn-success"
                      : "btn  btn-warning"
                    : "btn btn-warning btn-icon "
                }
                onClick={() =>
                  this.call(
                    data.queue ? data.queue.queue : "",
                    data.queue
                      ? data.queue.registration_clinic.clinic.name
                      : "",
                    data.queue ? data.queue.registration_clinic.clinic_id : "",
                    data
                  )
                }
              >
                <span className="btn-inner--icon">
                  <i className="fas fa-volume-up" style={{ fontSize: "18px" }}>
                    {" "}
                    {data.queue ? data.queue.queue : ""}
                  </i>
                </span>
              </button>

              {this.createBUtton(data, i)}
            </>,
            <div>
              <div>{data.clinics.name}</div>
              <div style={{ color: "blue" }}>
                {data.previous_clinic_id
                  ? data.previous_clinic_id !== 0
                    ? ` rujukan dari (${this.getPrevCLinic(
                        data.previous_clinic_id
                      )})`
                    : ""
                  : ""}
              </div>
            </div>,
            data.created_at,
            data.family_folder,
            data.insurance_no,
            data.patients.nik,
            `${data.patients.name} ${data.patients.last_name} (${moment().diff(
              data.patients.birth_date,
              "years"
            )} tahun)`,
            data.patients.sexs.name,
            moment(data.patients.birth_date).format("DD-MM-YYYY"),
            this.createBUttonDelete(data, i),
          ]}
          data={this.state.filteredDatas}
          url={"registration/read"}
          bodyRequest={this.props.keyword}
          callback={this.changeData}
        />
        {this.state.modal && (
          <ModalUpdateClinic
            show={this.state.modal}
            data={this.state.modalData}
            onHide={() => this.setState({ modal: false })}
            refData={{ ...this.props }}
          />
        )}
        {this.state.modalWa && (
          <ModalWa
            show={this.state.modalWa}
            data={this.state.modalWaData}
            onHide={() => this.setState({ modalWa: false })}
            refData={{ ...this.props }}
          />
        )}
        {this.state.modalProlanis && (
          <ModalUpdateProlanis
            show={this.state.modalProlanis}
            data={this.state.modalData}
            onHide={() => {
              this.setState({ modalProlanis: false });
              this.props.fetchDatas();
            }}
            refData={{ ...this.props }}
          />
        )}
      </div>
    );
  }
}

export default usePuskesmas(TablePelayanan);
